import React from "react";

import { Chip, ChipProps, Typography } from "@mui/material";

const ProcessingBadge = ({ sx, ...props }: ChipProps) => {
  return (
    <Chip
      {...props}
      sx={{
        height: "20px",
        bgcolor: "shades.neutral.150",
        "& .MuiChip-label": { px: 0.5 },
        ...sx,
      }}
      label={
        <Typography variant="labelMed" sx={{ color: "shades.neutral.600" }}>
          PROCESSING
        </Typography>
      }
    />
  );
};

export default ProcessingBadge;
